// eslint-disable-next-line import/prefer-default-export
export const checkoutURL = '/press-release/editor';
export const checkoutScreens = [
  { name: 'Contact', path: 'contact' },
  { name: 'Create', path: 'create' },
  { name: 'Review', path: 'review' },
  { name: 'Promote', path: 'promote' },
  { name: 'Complete Checkout', path: 'payment' },
  { name: 'Confirmation', path: 'confirmation' },
];
export const checkoutBreadcrumbs = checkoutScreens.filter((screen) => screen.path !== 'confirmation');
export const pressReleaseContactEmail = 'pressreleases@industrydive.com';
